import { createApp } from 'vue';
import GetTalentReportForm from '../../love/GetTlntReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-love-form-view')
Array.from(appElements).forEach(element => {
    createApp(GetTalentReportForm).mount(element);
});